export enum PremiumUnitsEnum {
  PERCENT = 'PERCENT',
  PER_DAY = 'PER_DAY',
  PER_HOUR = 'PER_HOUR',
  PER_KILOMETER = 'PER_KILOMETER',
  PER_WEEK = 'PER_WEEK'
}
